/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import OnboardingQuestions from "./OnboardingQuestions.container";

export default OnboardingQuestions;
